import React from 'react'
import './styles.scss'
import { Image } from 'react-bootstrap'
import { BsFillInfoCircleFill } from 'react-icons/bs'

export default function ProjectCard(props) {
    return (
        <div className="ProjectCard">
            <Image className="ProjectPic" src={props.Image} fluid />
            <div style={{ margin: '10px' }}>
                <div className="descrip">
                    <h4><u>{props.title}</u></h4>
                    <p className="para">{props.dscrip}</p>
                </div>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'end'}}>
                    <a href={props.infoURL} target="_blank" rel="noreferrer"><BsFillInfoCircleFill /> &nbsp;<i>More info</i></a>
                    {props.completed ? <h6 style={{color: 'green'}}>~ Completed</h6> : <h6 style={{color:'#c61752'}}>Working...</h6>}
                </div>
            </div>
        </div>
    )
}
